import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="agreement"
export default class extends Controller {
  static targets = ["checkbox", "submit"];

  action() {
    if (this.checkboxTarget.checked) {
      this.submitTarget.removeAttribute("aria-disabled");
    } else {
      this.submitTarget.setAttribute("aria-disabled", "true");
    }
  }
}
